import gql from 'graphql-tag'

export default gql`
  mutation updateUseOfFund($input: UpdateUseOfFundInput!) {
    updateUseOfFund(input: $input) {
      useOfFund {
        id
        businessAcquisition
        inventory
        hiring
        marketing
        operationalCosts
        newEquipment
      }
    }
  }
`
